import React, { useState } from "react";
import { analyzeImage } from "../utils/apiHelpers";

const WorkflowImage = () => {
  const [file, setFile] = useState(null);
  const [analysis, setAnalysis] = useState(null);

  // Handle file upload
  const handleUpload = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    const result = await analyzeImage(selectedFile);
    setAnalysis(result);
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <h2>Style Lab</h2>

      {/* Upload */}
      <input type="file" onChange={handleUpload} />

      {/* Analysis Output */}
      {analysis && (
        <div style={{ marginTop: "15px" }}>
          <p><b>Objects:</b> {analysis.objects}</p>
          <p><b>Colors:</b> {analysis.colors}</p>
          <p><b>Style:</b> {analysis.style}</p>
          <p><b>Description:</b> {analysis.description}</p>
        </div>
      )}
    </div>
  );
};

export default WorkflowImage;
